module.exports = __webpack_public_path__ + "static/img/service-h5-1.c4b697b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/service-h5-1.png
// module id = ILPq
// module chunks = 34